var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.modelName === 'Basic' ? _c('basic', {
    attrs: {
      "name": _vm.formDatas.name,
      "description": _vm.formDatas.description,
      "personnal": _vm.formDatas.data.personnal,
      "formations": _vm.formDatas.data.formations,
      "pros": _vm.formDatas.data.pros,
      "competences": _vm.formDatas.data.competences,
      "langues": _vm.formDatas.data.langues,
      "hobbies": _vm.formDatas.data.hobbies,
      "color": _vm.modelColor
    }
  }) : _vm.modelName === 'Basic2' ? _c('basic-2', {
    attrs: {
      "name": _vm.formDatas.name,
      "description": _vm.formDatas.description,
      "personnal": _vm.formDatas.data.personnal,
      "formations": _vm.formDatas.data.formations,
      "pros": _vm.formDatas.data.pros,
      "competences": _vm.formDatas.data.competences,
      "langues": _vm.formDatas.data.langues,
      "hobbies": _vm.formDatas.data.hobbies,
      "color": _vm.modelColor
    }
  }) : _vm.modelName === 'Basic3' ? _c('basic-3', {
    attrs: {
      "name": _vm.formDatas.name,
      "description": _vm.formDatas.description,
      "personnal": _vm.formDatas.data.personnal,
      "formations": _vm.formDatas.data.formations,
      "pros": _vm.formDatas.data.pros,
      "competences": _vm.formDatas.data.competences,
      "langues": _vm.formDatas.data.langues,
      "hobbies": _vm.formDatas.data.hobbies,
      "color": _vm.modelColor
    }
  }) : ['Dashboard', 'Dashboard2'].includes(_vm.modelName) ? _c('dashboard', {
    attrs: {
      "name": _vm.formDatas.name,
      "description": _vm.formDatas.description,
      "personnal": _vm.formDatas.data.personnal,
      "formations": _vm.formDatas.data.formations,
      "atouts": _vm.formDatas.data.atouts,
      "competences": _vm.formDatas.data.competences,
      "success": _vm.formDatas.data.success,
      "needs": _vm.formDatas.data.needs,
      "langues": _vm.formDatas.data.langues,
      "hobbies": _vm.formDatas.data.hobbies,
      "color": _vm.modelColor,
      "type-dashboard": _vm.modelName
    }
  }) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }